import React from 'react'
import styles from './Catalog.module.css'
import { CatalogImg } from '../../../Assets/Images/WindowsPage/Catalog'

const Catalog = () => {
  return (
    <section className={styles.wrap} id="catalog">
      <div className={`customContainer ${styles.container}`}>

        {/* Title */}
        <div className={styles.titles}>
          <hr className={styles.titles_line} />
          <h2 className={styles.titles_title}>Our Catalog</h2>
          <hr className={styles.titles_line} />
        </div>

        <div className={styles.content}>

          {/* LEFT — WINDOWS IMAGES */}
          <div className={styles.images}>
            <img src={CatalogImg} alt="window" className={styles.img} />
          </div>

          {/* RIGHT — TEXT BLOCK */}
          <div className={styles.textBlock}>
            <div className={styles.highlightBox}>
              <div className={styles.line}></div>
              <p className={styles.highlightText}>
                Discover our complete range of windows currently in-stock-crafted with precision and designed for
                performance.
                <br /><br />
                Each model in the catalog combines energy efficiency, reliability and aesthetic flexibility. Choose from
                available sizes, colors and technical specifications that meet your needs.
              </p>
            </div>


            <p className={styles.desc}>
              The XLeum window catalog offers a comprehensive selection of in-stock products, including casement and
              fixed models in a variety of standard and custom sizes. Each listing provides detailed technical
              specifications: frame type, glazing composition, hardware options and pricing, allowing you to easily find
              the right fit for your project. </p>

            <div className={styles.buttonsWrap}>
              <div className={styles.buttons}>
                <a href={'/catalog.pdf'} target="_blank"
                   rel="noopener noreferrer" className={styles.openBtn}>Open Catalog</a>
                <span className={styles.exploreBtn}>
Explore the full collection of European quality windows.</span>
              </div>
              <span className={`${styles.line} ${styles.lineMb}`}></span>

            </div>

          </div>
        </div>

      </div>
    </section>
  )
}

export default Catalog
